// extracted by mini-css-extract-plugin
export default {"form":"SignupForm_form__lhsOT","input":"SignupForm_input__rDUf7","button":"SignupForm_button__qSQKS","label":"SignupForm_label__s-Ubu"};